import AddRequirementForm from "../../features/CRUD/crudRequirementList/addRequirement/AddRequirement"


const AddRequirementPage  = () => {
  return (
    <div>
      <AddRequirementForm />
    </div>
  )
}

export default AddRequirementPage
